module.exports = __webpack_public_path__ + "static/media/attached-file-icon.068f578a.svg";